export const removePrefix =
  (pattern: RegExp, replaceWith = "") =>
  (item: string) =>
    item.replace(pattern, replaceWith).trim();
